<div style="background:#000; display:flex; justify-content:center; align-items:center;">
  <img [src]="data.url" style="max-width:90vw; max-height:90vh; object-fit:contain;" />
</div>